import { Component, Input } from '@angular/core';
import { ZenithComponentsModule } from '@mateco/zenith-webcomponents-angular/dist/zenith-webcomponents-angular';
import { TranslateModule } from '@ngx-translate/core';
import { Instance } from '../../../base/entities/transport.interface';

@Component({
  selector: 'app-instance-technical-details-card',
  standalone: true,
  imports: [TranslateModule, ZenithComponentsModule],
  templateUrl: './instance-technical-details-card.component.html'
})
export class InstanceTechnicalDetailsCardComponent {
  @Input() instance: Instance;
}
